import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

/**
 * Checks that the "Abregelbare Leistung KW" is not greater than the "installierte Leistung KW"
 * in the Aufteilungsschluessel of a Datenabfrage
 */
@Directive(
    {
        selector: '[tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte]',
        providers: [
            {
                provide: NG_VALIDATORS,
                useExisting: DatenabfrageAbregelbareLeistungLowerEqualsInstallierteValidatorDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class DatenabfrageAbregelbareLeistungLowerEqualsInstallierteValidatorDirective implements Validator {

    public static ERROR_KEY = 'tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte';

    @Input() tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte: string;

    validate(installierteLeistungControl: AbstractControl): ValidationErrors | null {
        if (this.tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte !== null &&
            typeof this.tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte !== 'undefined' &&
            parseFloat(this.tnbDatenabfrageAbregelbareLeistungLowerEqualsInstallierte) < parseFloat(installierteLeistungControl.value)) {
            const validationErrors = {};
            validationErrors[DatenabfrageAbregelbareLeistungLowerEqualsInstallierteValidatorDirective.ERROR_KEY] = true;
            return validationErrors;
        }
    }

}
